<template>
  <div>
    <Search v-if="!searchVisibility" />
    <v-card class="mb-4">
      <FilesToolbar />
      <v-list class="users_list pb-0" v-if="filesList">
        <div @dragleave="onFileDragLeave" @dragover="onFileDragOver">
          <v-list-tile>
            <v-layout row align-center class="caption" :class="paddingClass">
              <v-flex mr-2 v-if="isAdmin">
                <v-checkbox
                  color="blue-grey lighten-1"
                  v-model="allFilesActive"
                :disabled="checkboxDisabled"></v-checkbox>
              </v-flex>
              <FileIcon :additionalClass="'hidden-sm-and-down'" />
              <v-flex xs12 md4 lg4 class="font-weight-medium"
                v-if="!isMobile || sort_by === 'name'"
              >
                Nazwa
                <v-btn small flat icon
                   v-if="sort_by !== 'name'"
                   @click.prevent="setSort('name', 'asc')"
                   :disabled="noResults"
                   color="grey"
                   class="ma-0">
                  <v-icon small>arrow_upward</v-icon>
                </v-btn>

                <v-btn small flat icon
                   v-if="sort_by === 'name' && sort_dir === 'asc'"
                   @click.prevent="setSort('name', 'desc')"
                   :disabled="noResults"
                   :color="'primary'"
                   class="ma-0">
                  <v-icon
                    v-if="sort_dir === 'asc'"
                    small>arrow_upward</v-icon>
                </v-btn>

                <v-btn small flat icon
                   v-if="sort_by === 'name' && sort_dir === 'desc'"
                   @click.prevent="setSort('name', 'asc')"
                   :disabled="noResults"
                   :color="'primary'"
                   class="ma-0">
                  <v-icon
                    small>arrow_downward</v-icon>
                </v-btn>

              </v-flex>
              <v-flex xs12 md2
                v-if="!isMobile || sort_by === 'type'"
                class="font-weight-medium">
                Typ pliku
                <v-btn small flat icon
                       v-if="sort_by !== 'type'"
                       @click.prevent="setSort('type', 'asc')"
                       color="grey"
                       :disabled="noResults"
                       class="ma-0">
                  <v-icon small>arrow_upward</v-icon>
                </v-btn>

                <v-btn small flat icon
                       v-if="sort_by === 'type' && sort_dir === 'asc'"
                       @click.prevent="setSort('type', 'desc')"
                       :color="'primary'"
                       :disabled="noResults"
                       class="ma-0">
                  <v-icon small>arrow_upward</v-icon>
                </v-btn>

                <v-btn small flat icon
                       v-if="sort_by === 'type' && sort_dir === 'desc'"
                       @click.prevent="setSort('type', 'asc')"
                       :disabled="noResults"
                       :color="'primary'"
                       class="ma-0">
                  <v-icon small>arrow_downward</v-icon>
                </v-btn>

              </v-flex>
              <v-flex xs12 md2
                v-if="!isMobile || sort_by === 'created_at'"
                class="font-weight-medium">
                Data utworzenia

                <v-btn small flat icon
                       v-if="sort_by !== 'created_at'"
                       @click.prevent="setSort('created_at', 'asc')"
                       :disabled="noResults"
                       color="grey"
                       class="ma-0">
                  <v-icon small>arrow_upward</v-icon>
                </v-btn>

                <v-btn small flat icon
                       v-if="sort_by === 'created_at' && sort_dir === 'asc'"
                       @click.prevent="setSort('created_at', 'desc')"
                       :disabled="noResults"
                       :color="'primary'"
                       class="ma-0">
                  <v-icon small>arrow_upward</v-icon>
                </v-btn>

                <v-btn small flat icon
                       v-if="sort_by === 'created_at' && sort_dir === 'desc'"
                       @click.prevent="setSort('created_at', 'asc')"
                       :disabled="noResults"
                       :color="'primary'"
                       class="ma-0">
                  <v-icon small>arrow_downward</v-icon>
                </v-btn>

              </v-flex>
              <v-flex xs12 md3 lg2
                v-if="!isMobile || sort_by === 'last_modified_at'"
                class="font-weight-medium">
                Ostatnia modyfikacja

                <v-btn small flat icon
                       v-if="sort_by !== 'last_modified_at'"
                       @click.prevent="setSort('last_modified_at', 'asc')"
                       :disabled="noResults"
                       color="grey"
                       class="ma-0">
                  <v-icon small>arrow_upward</v-icon>
                </v-btn>

                <v-btn small flat icon
                       v-if="sort_by === 'last_modified_at' && sort_dir === 'asc'"
                       @click.prevent="setSort('last_modified_at', 'desc')"
                       :disabled="noResults"
                       :color="'primary'"
                       class="ma-0">
                  <v-icon small>arrow_upward</v-icon>
                </v-btn>

                <v-btn small flat icon
                       v-if="sort_by === 'last_modified_at' && sort_dir === 'desc'"
                       @click.prevent="setSort('last_modified_at', 'asc')"
                       :disabled="noResults"
                       :color="'primary'"
                       class="ma-0">
                  <v-icon small>arrow_downward</v-icon>
                </v-btn>

              </v-flex>
              <v-flex xs12 md2 small
                v-if="!isMobile || sort_by === 'size'"
                class="font-weight-medium">
                Rozmiar

                <v-btn small flat icon
                       v-if="sort_by !== 'size'"
                       @click.prevent="setSort('size', 'asc')"
                       :disabled="noResults"
                       color="grey"
                       class="ma-0">
                  <v-icon small>arrow_upward</v-icon>
                </v-btn>

                <v-btn small flat icon
                       v-if="sort_by === 'size' && sort_dir === 'asc'"
                       @click.prevent="setSort('size', 'desc')"
                       :disabled="noResults"
                       :color="'primary'"
                       class="ma-0">
                  <v-icon small>arrow_upward</v-icon>
                </v-btn>

                <v-btn small flat icon
                       v-if="sort_by === 'size' && sort_dir === 'desc'"
                       @click.prevent="setSort('size', 'asc')"
                       :disabled="noResults"
                       :color="'primary'"
                       class="ma-0">
                  <v-icon small>arrow_downward</v-icon>
                </v-btn>
              </v-flex>
              <v-spacer class="hidden-md-and-up"></v-spacer>
              <v-btn flat icon
                     :color="'primary'"
                     @click="sortVisibility = true"
                     class="ma-0 hidden-md-and-up align-sort">
                <v-icon>sort</v-icon>
              </v-btn>
            </v-layout>
          </v-list-tile>
          <v-divider></v-divider>
        </div>
        <div v-if="filesList && filesList.length === 0" class="px-4 py-4">
          <p class="mb-0 grey--text text--darken-1 body-2 font-weight-bold">
            {{noResultsText}}
          </p>
        </div>
        <FileItem
          v-for="(file, i) in filesList"
          :key="i"
          :index="i"
          :file="file"></FileItem>
      </v-list>
      <PermissionsDialog />
      <CreateFolderDialog />
      <RenameDialog />
      <DetailsDialog />
      <MoveDialog />
      <DeleteDialog />
      <TagsDialog />
      <ShareDialog />
      <PreviewDialog />
      <PermissionsAlertDialog />
      <div class="users_loader" v-if="!filesList">
        <div class="py-4 text-xs-center">
          <v-progress-circular
            :size="30"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
      </div>
    </v-card>
    <v-bottom-sheet v-model="sortVisibility">
      <v-list>
        <v-subheader>Sortuj według:
          <v-spacer></v-spacer>
          <v-btn
            @click.native="sortVisibility = false"
            icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-subheader>
        <v-list-tile
          :class="sort_by === 'name' ? 'primary white--text' : ''"
          @click.prevent="setSort('name', 'asc')"
        >
          <v-list-tile-title>
            Nazwie
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          @click.prevent="setSort('type', 'asc')"
          :class="sort_by === 'type' ? 'primary white--text' : ''"
        >
          <v-list-tile-title>
            Typie pliku
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          @click.prevent="setSort('created_at', 'asc')"
          :class="sort_by === 'created_at' ? 'primary white--text' : ''"
        >
          <v-list-tile-title>
            Dacie utworzenia
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          @click.prevent="setSort('last_modified_at', 'asc')"
          :class="sort_by === 'last_modified_at' ? 'primary white--text' : ''"
        >
          <v-list-tile-title>
            Dacie ostatniej modyfikcji
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          @click.prevent="setSort('size', 'asc')"
          :class="sort_by === 'size' ? 'primary white--text' : ''"
        >
          <v-list-tile-title>
            Rozmiarze
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-bottom-sheet>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import FileItem from './FileItem.vue';
import FileIcon from './FileIcon.vue';
import FilesToolbar from './FilesToolbar.vue';
import Search from './Search.vue';
import PermissionsDialog from './Dialogs/PermissionsDialog.vue';
import CreateFolderDialog from './Dialogs/CreateFolderDialog.vue';
import RenameDialog from './Dialogs/RenameDialog.vue';
import DetailsDialog from './Dialogs/DetailsDialog.vue';
import MoveDialog from './Dialogs/MoveDialog.vue';
import DeleteDialog from './Dialogs/DeleteDialog.vue';
import TagsDialog from './Dialogs/TagsDialog.vue';
import ShareDialog from './Dialogs/ShareDialog.vue';
import PreviewDialog from './Dialogs/PreviewDialog.vue';
import PermissionsAlertDialog from './Dialogs/PermissionsAlertDialog.vue';

export default {
  name: 'files-list',
  components: {
    FileItem,
    FileIcon,
    FilesToolbar,
    Search,
    PermissionsDialog,
    CreateFolderDialog,
    RenameDialog,
    DetailsDialog,
    MoveDialog,
    DeleteDialog,
    TagsDialog,
    ShareDialog,
    PreviewDialog,
    PermissionsAlertDialog,
  },
  data: () => ({
    sort_by: 'name',
    sort_dir: 'asc',
    sortVisibility: false,
    busy: false,
  }),
  computed: {
    ...mapGetters('files', [
      'filesList',
      'selectedFiles',
    ]),
    ...mapGetters('user', [
      'details',
      'role',
    ]),
    allFilesActive: {
      get() {
        return this.selectedFiles.length === this.filesList.length && this.filesList.length > 0;
      },
      set(val) {
        this.toggleAll(val);
      },
    },
    noResults() {
      return this.filesList.length <= 0;
    },
    isSearchPage() {
      return this.$route.name === 'searchFiles';
    },
    noResultsText() {
      return this.isSearchPage ? 'Brak wyników wyszukiwania.' : 'Wybrany katalog jest pusty.';
    },
    isAdmin() {
      return this.role === 'admin' || this.role === 'super-admin';
    },
    checkboxDisabled() {
      return this.$route.name === 'files' || this.noResults;
    },
    searchVisibility() {
      return this.$route.name === 'files' && this.isAdmin;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    paddingClass() {
      return this.isMobile ? 'px-0' : 'px-2';
    },
  },
  methods: {
    ...mapActions('files', [
      'setSelectedItem',
      'clearSelectedFiles',
      'setFileDragActivity',
    ]),
    setSort(name, dir) {
      this.sort_dir = dir;
      this.sort_by = name;
      const { query } = this.$route;
      const newQuery = {
        ...query,
        sort_by: name,
        sort_dir: dir,
      };
      this.sortVisibility = false;
      this.$router.push({ query: newQuery });
    },
    toggleAll(value) {
      if (value) {
        this.filesList.forEach((item) => {
          const singleFile = {
            id: item.id,
            type: item.type,
          };
          this.setSelectedItem(singleFile);
        });
      } else {
        this.clearSelectedFiles();
      }
    },
    onFileDragOver(event) {
      this.setFileDragActivity(true);
      if (event.dataTransfer.types.includes('Files')) {
        event.dataTransfer.dropEffect = 'copy';
      } else {
        event.dataTransfer.dropEffect = 'none';
      }
      event.preventDefault();
    },
    onFileDragLeave() {
      this.setFileDragActivity(false);
    },
  },
  mounted() {
    const { query } = this.$route;
    if (query.sort_dir) {
      this.sort_dir = query.sort_dir;
    }
    if (query.sort_dir) {
      this.sort_by = query.sort_by;
    }
  },
  watch: {
    $route() {
      const { query } = this.$route;
      this.sort_by = query.sort_by || 'name';
      this.sort_dir = query.sort_dir || 'asc';
    },
  },
};
</script>
